import { Flex } from 'antd';
import styled from 'styled-components';

export const StyledSummarySection = styled(Flex)`
    width: 50%;
`;

export const StyledStateWrapper = styled(Flex)`
    min-height: 240px;
`;
